<template>
  <span class="loading-text">Deleting your Data{{ dots }}</span>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'

const dots = ref('.')
const interval = ref<number | null>(null)

onMounted(() => {
  interval.value = window.setInterval(() => {
    if (dots.value === '.') {
      dots.value = '..'
    } else if (dots.value === '..') {
      dots.value = '...'
    } else {
      dots.value = '.'
    }
  }, 500) // Change dots every 500ms
})

onUnmounted(() => {
  if (interval.value !== null) {
    clearInterval(interval.value)
  }
})
</script>

<style scoped>
.loading-text {
  font-size: 1.2rem;
  font-weight: 500;
}
</style>
